import { classToPlain, plainToClass } from "class-transformer";
import { Clinic } from "src/shared/models/clinic.model";

class ClinicMapping {
    static fromJson(json: Record<string, unknown>): Clinic {
        return plainToClass(Clinic, json);
    }

    static toJson(clinic: Clinic): Record<string, unknown> {
        return classToPlain(clinic);
    }

    static fromJsonArray(jsonArray: Record<string, unknown>[]): Clinic[] {
        return jsonArray.map((json) => plainToClass(Clinic, json));
    }

    static toJsonArray(clinics: Clinic[]): Record<string, unknown>[] {
        return clinics.map((clinic) => classToPlain(clinic));
    }
}

export { ClinicMapping };
